// src/services/multipart.js
// C-3: a FormData body always goes out as multipart/form-data.
// The app's axios instances default Content-Type to application/json, and
// axios 1.x answers a FormData body under that header by converting it to
// JSON — every file becomes {} (Report Issue's photos were lost this way).
// This interceptor removes the Content-Type of any FormData request, so axios
// passes the FormData through and the browser writes multipart/form-data with
// its own boundary. Installed on every instance (api.js, AuthContext,
// publicApi.js); a page never needs to set the header itself.
export function installMultipart(instance) {
  instance.interceptors.request.use((config) => {
    if (typeof FormData !== 'undefined' && config.data instanceof FormData && config.headers) {
      if (typeof config.headers.setContentType === 'function') config.headers.setContentType(false);
      else delete config.headers['Content-Type'];
    }
    return config;
  });
  return instance;
}
